<div id="mmWrapper" *ngIf="mentionMeService.isConfigured"></div>
